import { getCitiesData } from '../libs/apis/CityApi';

export const GET_CITIES_REQUEST = 'GET_CITIES_REQUEST';
export const GET_CITIES_SUCCESS = 'GET_CITIES_SUCCESS';
export const GET_CITIES_FAILURE = 'GET_CITIES_FAILURE';

export const getOptionCities = params => dispatch => {
  dispatch({ type: GET_CITIES_REQUEST });
  return getCitiesData(params)
    .then(response =>
      dispatch({
        type: GET_CITIES_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_CITIES_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
